export default __webpack_public_path__ + "static/media/revision.70585c54.png";